/* eslint-disable react/prop-types */
import React, { useMemo } from "react";
import TableLayout from "./table-layout";
import PropTypes from "prop-types";
import { useSortBy, useTable } from "react-table";
import "../../styles/Tableinstance.scss";
import { CARTS_COLUMN } from "./Constants";

function TableInstance({ tableData, setPageSort, pageSort }) {
    const [columns, data] = useMemo(() => {
        return [CARTS_COLUMN, tableData];
    }, [tableData]);

    const tableInstance = useTable(
        {
            columns,
            data,
            initialState: { sortBy: pageSort },
            manualSortBy: true,
            autoResetSortBy: false,
            autoResetExpanded: false,
            autoResetPage: false,
        },
        useSortBy
    );

    return (
        <TableLayout
            {...tableInstance}
            setPageSort={setPageSort}
        />
    );
}

export default TableInstance;

TableInstance.propTypes = {
    tableData: PropTypes.array.isRequired,
    setPageSort: PropTypes.any,
    pageSort: PropTypes.any,
};
